import { Box } from '@hivebrite/design-system/Box';
import { Container } from '@hivebrite/design-system/Container';

import FolderPageHeader from 'hb-react/shared/components/FolderPageHeader';
import FolderPageHeaderLoader from 'hb-react/shared/components/FolderPageHeader/Loader';

const MediaCenterFolderPageHeader = ({ currentFolder, isLoading }) => {
  if (isLoading) {
    return (
      <Wrapper>
        <FolderPageHeaderLoader />
      </Wrapper>
    );
  }

  if (!currentFolder) {
    return null;
  }

  return (
    <Wrapper>
      <FolderPageHeader folder={currentFolder} />
    </Wrapper>
  );
};

const Wrapper = ({ children }) => (
  <Container display="block" height="auto">
    <Box display="block" mt={6} pb={2}>
      {children}
    </Box>
  </Container>
);

export default MediaCenterFolderPageHeader;
